"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSizePropertyCheck = _interopRequireDefault(require("./_createSizePropertyCheck.js"));

var _getByteLength = _interopRequireDefault(require("./_getByteLength.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
var _default = (0, _createSizePropertyCheck.default)(_getByteLength.default);

exports.default = _default;